import { render, staticRenderFns } from "./GroupChart.vue?vue&type=template&id=2f1a8c80"
import script from "./GroupChart.vue?vue&type=script&lang=js"
export * from "./GroupChart.vue?vue&type=script&lang=js"
import style0 from "./GroupChart.vue?vue&type=style&index=0&id=2f1a8c80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports